<div class="structuredProcessWorkplan_container">
  <button mat-button type="button" class="workplan-back-button" (click)="onBackToChat()">
    <mat-icon>chevron_left</mat-icon>
    {{ 'structuredProcessView.workplan.back' | translate }}
  </button>
  <div class="app-toolbar">
    @if (!isMobileView) {
      <span class="title">{{ isGeneratingArtifact ? ('structuredProcessView.workplan.generatingWorkplan' | translate) : (workplan()?.name || 'Workplan') }}</span>
    }
    @else {
      <span class="title">{{ isGeneratingArtifact ? ('structuredProcessView.workplan.generatingWorkplan' | translate) : ('structuredProcessView.workplan.generalTitle' | translate) }}</span>
    }
      <span class="spacer"></span>
    
      <!-- <button mat-raised-button color="primary" class="ml16" (click)="save()" [disabled]="saving() || !dirty() || isGeneratingArtifact">
        <mat-icon class="mr4">{{ saving() ? 'hourglass_bottom' : 'save' }}</mat-icon>
        {{ saving() ? 'Saving...' : 'Save workplan' }}
      </button> -->
      @if (!isGeneratingArtifact) {
        @if (isSaving()) {
          <span class="workplan-save-status">{{ 'structuredProcessView.workplan.savingWorkplan' | translate }}</span>
        }
        @else {
          <span class="workplan-save-status">{{ 'structuredProcessView.workplan.upToDate' | translate }}</span>
        }
      }

      <button mat-icon-button aria-label="download" [style.display]="'flex'" [style.align-items]="'center'" [style.justify-content]="'center'" (click)="downloadWorkplan()">
        <mat-icon>download</mat-icon>
      </button>
  </div>
    <!-- WORKPLAN GENERATED STATE -->
    @if (!isGeneratingArtifact && workplan() != null) {
    <div class="meta">
      <div class="meta-row">
        <!-- <div class="meta-item"><mat-icon>event</mat-icon>
          <span *ngIf="workplan()!.dueDate; else noDue">{{ 'structuredProcessView.workplan.dueDate' | translate }} {{ workplan()!.dueDate | date:'MMM d' }}</span>
          <ng-template #noDue><span>{{ 'structuredProcessView.workplan.noDueDate' | translate }}</span></ng-template>
        </div> -->
        <div class="meta-item"><mat-icon>view_agenda</mat-icon>
          <span>{{ totalMilestones() }} {{ 'structuredProcessView.workplan.milestones' | translate }}</span>
        </div>
        <div class="meta-item"><mat-icon>check_circle</mat-icon>
          <span>{{ completedMilestones() }}/{{ totalMilestones() }} {{ 'structuredProcessView.workplan.complete' | translate }}</span>
        </div>
      </div>
      <mat-progress-bar mode="determinate" [value]="milestoneProgressPct()"></mat-progress-bar>
      <div class="progress-caption">{{ completedMilestones() }}/{{ totalMilestones() }}</div>
    </div>
    
    <div class="milestones">
      <mat-accordion multi class="structuredProcessWorkplan_milesstonesContainer">
        <mat-expansion-panel *ngFor="let m of workplan()!.milestones; trackBy: trackMs"
        class="structuredProcessWorkplan_singleMilesstoneContainer"
        [expanded]="isExpanded(m.idx)"
        (opened)="setExpanded(m.idx, true)"
        (closed)="setExpanded(m.idx, false)">
          <mat-expansion-panel-header class="structuredProcessWorkplan_singleMilesstoneHeader">
            <mat-panel-title>
              <div class="ms-title">
                <div class="ms-number">{{ m.idx }}</div>
                <div>
                  <div class="ms-name">{{ m.name }}</div>
                  <div class="ms-desc" *ngIf="m.description">{{ m.description }}</div>
                  <div class="ms-meta">
                    <mat-chip-set>
                      <mat-chip-option
                      [selected]="true"
                      [selectable]="false"
                      matRippleDisabled
                      appearance="outlined"
                      [color]="m.status==='DONE' ? 'primary' : (m.status==='IN_PROGRESS' ? 'accent' : undefined)">
                      {{ m.status === 'PENDING' ? ('structuredProcessView.workplan.status.pending' | translate) : m.status === 'IN_PROGRESS' ? ('structuredProcessView.workplan.status.inProgress' | translate) : ('structuredProcessView.workplan.status.done' | translate) }}
                    </mat-chip-option>
                      <!-- <mat-chip-option appearance="outlined" [selectable]="false" matRippleDisabled
                                *ngIf="m.dueDate">{{ 'structuredProcessView.workplan.dueDate' | translate }} {{ m.dueDate | date:'MMM d' }}</mat-chip-option> -->
                      <mat-chip-option appearance="outlined" [selectable]="false" matRippleDisabled>
                          {{ doneCount(m) }}/{{ m.tasks.length }} {{ 'structuredProcessView.workplan.tasks' | translate }}
                      </mat-chip-option>
                    </mat-chip-set>
                  </div>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
    
          <div cdkDropList (cdkDropListDropped)="dropTask($event, m)" class="task-list">
            <div *ngFor="let t of m.tasks; trackBy: trackTask" cdkDrag>
              <div class="task-row" [class.bold]="isTaskIsEditted(m.idx, t.idx) || isTaskIsDeleted(m.idx, t.idx)">
                <div class="task-container">
                  <div class="drag-handle" cdkDragHandle matTooltip="Drag to reorder" *ngIf="!isTaskIsEditted(m.idx, t.idx)">
                    <mat-icon>drag_indicator</mat-icon>
                  </div>
        
                  @if (!isTaskIsEditted(m.idx, t.idx) && !isTaskIsDeleted(m.idx, t.idx)) {
                    <mat-checkbox [disabled]="isTaskIsEditted(m.idx, t.idx)" [checked]="t.status==='DONE'" (change)="toggleTaskDone(m, t)" class="task-checkbox"></mat-checkbox>
                  }
                  <div class="task-main">
                      <div class="task-title-container">
                        @if (!isTaskIsEditted(m.idx, t.idx) && !isTaskIsDeleted(m.idx, t.idx)) {
                        <div class="task-title" [class.done]="t.status==='DONE'" [ngClass]="{'is-mobile-view': isMobileView}">{{ t.name }}</div>                    
                        <div class="task-description" [ngClass]="{'is-mobile-view': isMobileView}" *ngIf="t.description">{{ t.description }}</div>
                        <div class="task-title-actions-container">
                          <!-- <button mat-icon-button [disabled]="isTaskIsEditted(m.idx, t.idx)" class="task-date-small-button" [matMenuTriggerFor]="pickerMenu" aria-label="Pick due date">
                            <mat-icon class="task-date-button-icon small">event</mat-icon>
                          </button>  -->
                          @if (!isMobileView) {
                            <div class="task-title-date-container">
                              <button mat-icon-button class="task-date-small-button" (click)="picker.open()" aria-label="Pick due date">
                                <mat-icon class="task-date-button-icon small">event</mat-icon>
                              </button>
                              @if (t.dueDate){
                                <span class="task-title-date" >| {{ t.dueDate | date:'d MMM' : '': user!.locale }}</span>
                                <button mat-icon-button [disabled]="isTaskIsEditted(m.idx, t.idx)" class="task-date-small-button" (click)="clearTaskDate(t, $event)" aria-label="Clear due date">
                                  <mat-icon class="task-date-button-icon small">close</mat-icon>
                                </button>                       
                              }
                            </div>
                          }
                        </div>
                        }
                        @else if (isTaskIsEditted(m.idx, t.idx)) {
                          <mat-form-field appearance="fill"  class="w-full input-light">
                            @if (draftName() === '') {
                            <mat-label>{{ 'structuredProcessView.workplan.taskName' | translate }}</mat-label>
                            }
                            <input
                              matInput
                              [ngModel]="draftName()"
                              (ngModelChange)="draftName.set($event)"
                              [ngModelOptions]="{ standalone: true }"
                              (keyup.enter)="saveTaskEdit()"
                            />
                            
                          </mat-form-field>
                    
                          <mat-form-field appearance="fill"  class="w-full input-light">
                            @if (draftDescription() === '') {
                            <mat-label>{{ 'structuredProcessView.workplan.description' | translate }}</mat-label>
                            }
                            <input
                              matInput
                              rows="2"
                              [ngModel]="draftDescription()"
                              (ngModelChange)="draftDescription.set($event)"
                              [ngModelOptions]="{ standalone: true }"
                              (keydown.escape)="cancelTaskEdit()"
                            />
                            </mat-form-field>
                        } 
                        @else if (isTaskIsDeleted(m.idx, t.idx)) {
                          <div class="task-title-container">
                            <div class="task-title">{{ "structuredProcessView.workplan.deleteTaskText" | translate : {taskName: t.name} }}</div>
                          </div>
                        }
    
                      </div>
        
                      <input
                      matInput
                      [matDatepicker]="picker"
                      [(ngModel)]="t.dueDate"
                      (dateChange)="onCalendarSelect(t, $event.value)"
                      [ngModelOptions]="{ standalone: true }"
                      class="visually-hidden"
                      />
                      <mat-datepicker #picker></mat-datepicker>
                      @if (!isMobileView) {
                      <div class="task-actions"> 
                        @if (!isTaskIsEditted(m.idx, t.idx) && !isTaskIsDeleted(m.idx, t.idx)) {  
                        <button mat-icon-button aria-label="delete task" (click)="editTask(m.idx, t.idx)">
                            <mat-icon class="task-date-button-icon">edit</mat-icon>
                        </button>                
                          <button mat-icon-button aria-label="delete task" (click)="deleteTask(m.idx, t.idx)">
                            <mat-icon class="task-date-button-icon">delete</mat-icon>
                        </button>                    
                          <!-- Clear icon shows only when a date exists -->            
                        }
                        @else if (isTaskIsEditted(m.idx, t.idx)) {
                          <button mat-icon-button aria-label="save task edit" (click)="saveTaskEdit()">
                            <mat-icon class="task-date-button-icon green">check</mat-icon>
                          </button>                
                          <button mat-icon-button aria-label="cancel task edit" (click)="cancelTaskEdit()">
                            <mat-icon class="task-date-button-icon red">close</mat-icon>
                          </button>                             
                        }
                        @else if (isTaskIsDeleted(m.idx, t.idx)) {
                          <button mat-icon-button aria-label="confirm task deletion" (click)="confirmTaskDeletion()">
                            <mat-icon class="task-date-button-icon green">check</mat-icon>
                          </button>                
                          <button mat-icon-button aria-label="cancel task deletion" (click)="cancelTaskDeletion()">
                            <mat-icon class="task-date-button-icon red">close</mat-icon>
                          </button>                             
                        }
                      </div>
                      }
                  </div>
                </div>
                
                @if (isMobileView) {
                  <div class="task-actions-bottom">
                    <div class="task-title-date-container">
                      <button mat-icon-button class="task-date-small-button" (click)="picker.open()" aria-label="Pick due date">
                        <mat-icon class="task-date-button-icon small">event</mat-icon>
                      </button>
                      @if (t.dueDate){
                        <span class="task-title-date" >| {{ t.dueDate | date:'d MMM' : '': user!.locale }}</span>
                        <button mat-icon-button [disabled]="isTaskIsEditted(m.idx, t.idx)" class="task-date-small-button" (click)="clearTaskDate(t, $event)" aria-label="Clear due date">
                          <mat-icon class="task-date-button-icon small">close</mat-icon>
                        </button>                       
                      }
                    </div>
                    <div class="task-actions" [ngClass]="{'is-mobile-view': isMobileView}"> 
                      @if (!isTaskIsEditted(m.idx, t.idx) && !isTaskIsDeleted(m.idx, t.idx)) {  
                      <button class="task-date-small-button" mat-icon-button aria-label="delete task" (click)="editTask(m.idx, t.idx)">
                          <mat-icon class="task-date-button-icon">edit</mat-icon>
                      </button>                
                        <button class="task-date-small-button" mat-icon-button aria-label="delete task" (click)="deleteTask(m.idx, t.idx)">
                          <mat-icon class="task-date-button-icon">delete</mat-icon>
                      </button>                    
                        <!-- Clear icon shows only when a date exists -->            
                      }
                      @else if (isTaskIsEditted(m.idx, t.idx)) {
                        <button class="task-date-small-button" mat-icon-button aria-label="save task edit" (click)="saveTaskEdit()">
                          <mat-icon class="task-date-button-icon green">check</mat-icon>
                        </button>                
                        <button class="task-date-small-button" mat-icon-button aria-label="cancel task edit" (click)="cancelTaskEdit()">
                          <mat-icon class="task-date-button-icon red">close</mat-icon>
                        </button>                             
                      }
                      @else if (isTaskIsDeleted(m.idx, t.idx)) {
                        <button class="task-date-small-button" mat-icon-button aria-label="confirm task deletion" (click)="confirmTaskDeletion()">
                          <mat-icon class="task-date-button-icon green">check</mat-icon>
                        </button>                
                        <button class="task-date-small-button" mat-icon-button aria-label="cancel task deletion" (click)="cancelTaskDeletion()">
                          <mat-icon class="task-date-button-icon red">close</mat-icon>
                        </button>                             
                      }
                    </div>                         
                  </div>
                }
              </div>
            </div>

            <div class="task-row new" (click)="addTask(m)">
              <mat-icon class="task-row-icon">add</mat-icon>
              <div class="task-title-container">
                <div class="task-title">{{ "structuredProcessView.workplan.addTaskTitle" | translate }}</div>
                <span class="task-title-description" >{{ 'structuredProcessView.workplan.addTaskDescription' | translate }}</span>
              </div>            
            </div>


          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    
    <mat-card class="bottom-summary">
      <div class="summary-row">
        <div class="summary-item"><mat-icon>task_alt</mat-icon>
          <span>{{ completedTasks() }}/{{ totalTasks() }} {{ 'structuredProcessView.workplan.tasksComplete' | translate }}</span>
        </div>
        <mat-progress-bar mode="determinate" [value]="taskProgressPct()"></mat-progress-bar>
      </div>
    </mat-card>
    }
    @else {
      <!-- EMPTY STATE - WORKPLAN GENERATION -->
      <div class="empty-state-workplan-container">
        <div
        class="circle-spinner"
        [class.is-loading]="isGeneratingArtifact"
        role="status"
        [attr.aria-busy]="isGeneratingArtifact"
      >
        <mat-progress-spinner
          class="spinner"
          mode="indeterminate"
          [strokeWidth]="3"
        ></mat-progress-spinner>
      
        <mat-icon class="center-icon">auto_fix_high</mat-icon>
        </div>  
        <div class="empty-state-workplan-text">
            <h1 class="empty-state-workplan-text-header">{{ 'structuredProcessView.workplan.generatingWorkplanTextHeader' | translate }}</h1>
            <span class="empty-state-workplan-text-description">{{ 'structuredProcessView.workplan.generatingWorkplanTextDescription' | gender | translate }}</span>
        </div>
        <div class="empty-state-workplan-steps">
          <div class="empty-state-workplan-step" *ngFor="let s of emptyStateSteps; index as i" [style.--i]="i">
            <span class="dot"></span>
            <span class="emoji" aria-hidden="true">{{ s.emoji }}</span>
            <span class="empty-state-workplan-step-label">{{ s.text }}</span>
          </div>
        </div>      
      </div>
    }
</div>